import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Tracker from "./pages/Tracker";
import AdminPanel from "./pages/AdminPanel";
import Profile from "./pages/Profile";
import PublicProfile from "./pages/PublicProfile";
import MerchPage from "./pages/MerchPage";
import { Toaster } from "./components/ui/toaster";
import { ThemeProvider } from "./contexts/ThemeContext";
import { AuthProvider } from "./contexts/AuthContext";
import AuthDialog from "./components/AuthDialog";
import RandomQuotePopup from "./components/RandomQuotePopup";
import ChatBubble from "./components/ChatBubble";
import InstallAppPrompt from "./components/InstallAppPrompt";
import IntroSplash from "./components/IntroSplash";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <div className="App">
          <IntroSplash />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Tracker />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/u/:username" element={<PublicProfile />} />
              <Route path="/admin" element={<AdminPanel />} />
              <Route path="/merch" element={<MerchPage />} />
            </Routes>
          </BrowserRouter>
          <AuthDialog />
          <RandomQuotePopup />
          <ChatBubble />
          <InstallAppPrompt />
          <Toaster />
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
